import { render, staticRenderFns } from "./42.vue?vue&type=template&id=68e867a7&"
import script from "./42.vue?vue&type=script&lang=js&"
export * from "./42.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports